export class ChangePinModel {
  uId?: string;
  pinCustomer: string;
  status: string;
  statusCustomer?: string;
  statusBusiness?: string;
}
